var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('DynamicForm',{attrs:{"form":"academic_procedure_form","title":"Edit Academic Procedure","initialData":_vm.initialData,"handleSubmit":_vm.handleSubmit,"cancelLink":"academicProcedures"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }